import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/contact/ContactClient.tsx");
